import { render, staticRenderFns } from "./KoioteNavigation.vue?vue&type=template&id=493ea252&scoped=true&v-if=input"
import script from "./KoioteNavigation.vue?vue&type=script&lang=js"
export * from "./KoioteNavigation.vue?vue&type=script&lang=js"
import style0 from "./KoioteNavigation.vue?vue&type=style&index=0&id=493ea252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493ea252",
  null
  
)

export default component.exports